<aurora-button
    variant="ghost"
    iconLeft="plus"
    [loading]="loading"
    [disabled]="loading"
    (click)="tryCreateNewAccount()">
    New {{ "Account" | smNomenclatureByRegion : null | async }}
</aurora-button>

<account-clearance-chat-modal *ngIf="clearanceChatOpen"
    (createAccount)="onClearanceCreateAccount()"
    (accountSelected)="onClearanceAccountSelected($event)"
    (cancel)="clearanceChatOpen = false">
</account-clearance-chat-modal>
